import { useSelector, TypedUseSelectorHook } from 'react-redux'
import { RootState } from 'featureSliced/shared/store'

export const useMySelector: TypedUseSelectorHook<RootState> = useSelector
